module.exports = __webpack_public_path__ + "img/校园足球LOGO.b47e8a1e.png";